// @flow
import { colors, breakpoints as bp } from '@foxford/ui/lib/utils/export'

// bp = {"l":"1279px","m":"1023px","s":"767px","xs":"374px"}

export type Breakpoints = {
  [key: string]: number,
}

export type Fonts = {
  [key: string]: string,
}

export type Theme = {
  colors: { [string]: string },
  baseColors: { [string]: string },
  socialColors: { [string]: string },
  themeColors: { [string]: string },
  breakpoints: Breakpoints,
  fonts: Fonts,
}

const breakpoints: Breakpoints = {
  xl: 1439,
  xxs: 319,
}

Object.keys(bp).forEach((key) => {
  breakpoints[key] = parseInt(bp[key])
})

const fonts: Fonts = {
  primary: "'Circe', sans-serif",
}

export const defaultTheme: Theme = {
  ...colors,
  breakpoints,
  fonts,
}
